<ng-container *ngIf="showControl()">
  <div class="label-wrapper">
    <mat-label *ngIf="label && control.type !== 'MULTICONTROL'" class="control-label">{{ label }}</mat-label>
    <button
      *ngIf="hasHistoricalFailures()"
      mat-icon-button
      type="button"
      class="failures-history-button tiny-icon-button"
      [class.no-label]="!label"
      [matTooltip]="'FAILURES_HISTORY' | translate"
      (click)="failureHistoryEvent.emit()"
    >
      <mat-icon>history</mat-icon>
    </button>
  </div>
  <item-description [description]="description"></item-description>
  <span *ngIf="customValue && !control.enableIfFailure" class="custom-label"><b *ngIf="customLabel">{{ customLabel }}: </b> {{ customValue }}</span>
  <ng-container [ngSwitch]="control.type">
    <mat-form-field *ngSwitchCase="'TEXT'">
      <input matInput [formControl]="formControl" [attr.minlength]="getMinLength()" [attr.maxlength]="getMaxLength()" [placeholder]="'TEXT_PLACEHOLDER' | translate">
      <mat-error *ngFor="let error of getErrorMessages()">{{error | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'DECIMAL_NUMBER'">
      <input matInput  [formControl]="formControl" type="number" [attr.min]="getMinValue()" [attr.max]="getMaxValue()" [placeholder]="'NUMBER_PLACEHOLDER' | translate">
      <mat-error *ngFor="let error of getErrorMessages()">{{error | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'NUMBER'">
      <input matInput  [formControl]="formControl" type="number" [attr.min]="getMinValue()" [attr.max]="getMaxValue()" onlynumber>
      <mat-error *ngFor="let error of getErrorMessages()">{{error | translate }}</mat-error>
    </mat-form-field>

    <div *ngSwitchCase="'RADIO'">
      <mat-radio-group [formControl]="formControl" class="radio-group">
        <mat-radio-button *ngFor="let option of control?.options" [value]="option.value">
          {{ option.label }}
        </mat-radio-button>
        <ng-container *ngIf="formControl.touched && !!getErrorMessages()">
          <div class="checkbox-error" *ngFor="let error of getErrorMessages()">{{error | translate }}</div>
        </ng-container>
      </mat-radio-group>
    </div>

    <mat-form-field *ngSwitchCase="'LIST'">
      <mat-select [formControl]="formControl" [placeholder]="'SELECT' | translate">
        <mat-option *ngFor="let option of control?.options" [value]="option.value">
          {{ option.label }}
        </mat-option>
      </mat-select>
      <mat-error *ngFor="let error of getErrorMessages()">{{error | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'MULTISELECT'">
      <mat-select [formControl]="formControl" [multiple]="true" [placeholder]="'SELECT' | translate">
        <mat-option *ngFor="let option of control?.options" [value]="option.value">
          {{ option.label }}
        </mat-option>
      </mat-select>
      <mat-error *ngFor="let error of getErrorMessages()">{{error | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'TEMPERATURE'">
      <input matInput  [formControl]="formControl" type="number">
      <span matTextSuffix>&nbsp;°C</span>
      <button
        *ngIf="!readonly"
        mat-icon-button
        matSuffix
        type="button"
        (click)="refreshTemperature()"
      ><mat-icon>refresh</mat-icon>
      </button>
      <mat-error *ngFor="let error of getErrorMessages()">{{error | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'DATE'">
      <input
        matInput
        [matDatepicker]="datePicker"
        [max]="today"
        [formControl]="formControl"
        readonly
      >
      <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
      <mat-datepicker #datePicker></mat-datepicker>
      <mat-error *ngFor="let error of getErrorMessages()">{{error | translate }}</mat-error>
    </mat-form-field>

    <mat-form-field *ngSwitchCase="'TEXTAREA'">
      <textarea [rows]="2" matInput [formControl]="formControl"></textarea>
      <mat-error *ngFor="let error of getErrorMessages()">{{error | translate }}</mat-error>
    </mat-form-field>

    <ng-container *ngSwitchCase="'PHOTO'">
      <files-list
        [formControl]="formControl"
        type="PHOTO"
        (uploadEvent)="uploadFile($event)"
        (deleteFileEvent)="deleteFile($event)"
        [disableUpload]="false"
        [disableDelete]="false"
        [maxFiles]="photoMaxFiles"
        [hintKey]="photoHintKey"
        [offlineMode]="!((networkStatus$ | async) ?? true)"
        [header]="''"
      ></files-list>
      <ng-container *ngIf="formControl.touched && formControl.errors">
        <div class="checkbox-error" >{{ getFileError() }}</div>
      </ng-container>
    </ng-container>

    <multicontrol *ngSwitchCase="'MULTICONTROL'" [formControl]="formControl" [controls]="control.controls" [readonly]="readonly">
      <dynamic-control
        *ngFor="let subcontrol of control.controls"
        [control]="subcontrol"
        [label]="subcontrol.label"
        [controlName]="previewMode ? subcontrol.id.toString() : subcontrol.templateFormControlId.toString()"
        [value]="subcontrol.value || ''"
      ></dynamic-control>
      <mat-error *ngFor="let error of getErrorMessages()">{{error | translate }}</mat-error>
    </multicontrol>

    <ng-container *ngSwitchCase="'MAP'">
      <map
        *ngIf="mapReady()"
        [enableGeolocation]="!readonly"
        [coordinates]="value"
        [isDynamicControl]="true"
        [showError]="formControl.touched && formControl.invalid"
        (coordinatesEvent)="setLocation($event)">
      </map>
    </ng-container>

  </ng-container>
</ng-container>

